export function memberName(user) {
  return user?.displayName?.trim() || 'Paddock member';
}
